// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"8680":"fe581f21","8869":"5b22a289"}[chunkId] + ".css";
};